export default "__VITE_ASSET__CcKlmPjn__"